import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    justifyRight: {},
    paperHeader: {
      justifyContent: 'space-between'
    },
    mt1: {
      marginTop: theme.spacing(1)
    },
    mt2: {
      marginTop: theme.spacing(2)
    },
    noDataBox: {
      minHeight: 75,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'gray'
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    },
    suppliesTable: {
      marginTop: theme.spacing(1)
    },
    headerIcon: {
      color: theme.palette.primary.main
    },
    autoAlign: {
      alignItems: 'center',
      padding: theme.spacing(1),
      paddingLeft: 0,
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end'
      }
    },
    spinnerBox: {
      marginTop: 32,
      marginBottom: 32
    }
  });
});
